import React from 'react';

import { MENU_TILE_GRID_HALF_GAP } from 'features/menu/components/menu-tile-grid/styled';
import { Platform, StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

const isWeb = Platform.OS === 'web';
const menuSectionGridItemWrapperWebStyle = ({
  maxWidth: `calc(33% - ${MENU_TILE_GRID_HALF_GAP}px)`,
} as unknown) as ViewStyle;

type MenuSectionGridFooterProps = BoxProps & {
  isMenuItem: boolean;
};

export const MenuSectionGridItemWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      menuSectionStyles.menuSectionGridItemWrapper,
      isWeb && menuSectionGridItemWrapperWebStyle,
      style,
    ],
  });

const MENU_IMAGE_MOBILE_WIDTH = 104;
const MENU_IMAGE_DESKTOP_WIDTH = 248;

export const menuSectionStyles = StyleSheet.create({
  menuSectionGridFooter: {
    alignItems: 'center',
    borderBottomLeftRadius: primitive.$borderRadius,
    borderBottomRightRadius: primitive.$borderRadius,
    justifyContent: 'center',
  },
  menuSectionGridFooterMenuItem: {
    height: 92,
  },
  menuSectionGridFooterSection: {
    height: 54,
  },
  menuSectionGridItemWrapper: {
    alignItems: 'center',
    borderRadius: 12,
    flex: 1,
    justifyContent: 'center',
    margin: MENU_TILE_GRID_HALF_GAP,
    minHeight: 220,
  },
  menuSectionRow: {
    flexShrink: 1,
    flexGrow: 1,
    minHeight: 112,
    alignItems: 'center',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$2,
    flexDirection: 'row',
  },
  menuSectionImageWrapper: {
    minWidth: MENU_IMAGE_MOBILE_WIDTH,
  },
  menuSectionImage: {
    width: MENU_IMAGE_MOBILE_WIDTH,
    height: MENU_IMAGE_MOBILE_WIDTH,
    borderRadius: 10,
  },
  menuSectionImageDesktop: {
    width: MENU_IMAGE_DESKTOP_WIDTH,
    height: MENU_IMAGE_DESKTOP_WIDTH,
    borderRadius: 10,
  },
  menuSectionContent: {
    flex: 1,
    flexShrink: 1,
    paddingHorizontal: spacing.$3,
  },
  menuSectionProductWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: spacing.$1,
  },
});

export const MenuSectionGridFooter = ({
  isMenuItem,
  style,
  ...props
}: MenuSectionGridFooterProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      menuSectionStyles.menuSectionGridFooter,
      isMenuItem
        ? menuSectionStyles.menuSectionGridFooterMenuItem
        : menuSectionStyles.menuSectionGridFooterSection,
      style,
    ],
  });

export const MenuSectionGridFooterTitle = withTypography({
  variant: 'headerTwo',
  color: getDesignToken('text-default'),
  m: '$0',
  fontSize: 'lg',
  lineHeight: 20,
  textAlign: 'center',
});
